<div class="br-wrap" [ngStyle]="themeVars" [class.br-wrap--expanded]="expandedView">

	<!-- ── Floating accent icon ─────────────────────────────────────────────── -->
	<div class="br-icon-badge">
		<i class="material-icons">storefront</i>
	</div>

	<!-- ── Header ───────────────────────────────────────────────────────────── -->
	<div class="br-header">

		<!-- Breadcrumbs + title -->
		<div class="br-title-group">
			<ng-container *ngIf="drillStack.length > 0">
				<button class="br-crumb-btn" (click)="drillBack()" title="Back">
					<i class="material-icons">arrow_back_ios</i>
					<span>{{ drillStack[drillStack.length - 1].title }}</span>
				</button>
				<i class="material-icons br-crumb-sep">chevron_right</i>
			</ng-container>
			<span class="br-title">{{ charttitle }}</span>
			<span class="br-subtitle" *ngIf="fromdateCtrl.value && todateCtrl.value">
				{{ fromdateCtrl.value | date:'MMM d' }} – {{ todateCtrl.value | date:'MMM d, y' }}
			</span>
		</div>

		<div class="br-actions">
			<!-- Back button (prominent, shown when drilled in) -->
			<button class="br-back-btn" *ngIf="drillStack.length > 0" (click)="drillBack()" title="Back to {{ drillStack[drillStack.length-1].title }}">
				<i class="material-icons">undo</i> Back
			</button>

			<button class="br-icon-btn" *ngIf="detaillabel"
					(click)="anyDetailOpen ? collapseAllDetails() : expandAllDetails()"
					[title]="anyDetailOpen ? 'Collapse all details' : 'Expand all ' + detaillabel + ' details'">
				<i class="material-icons">{{ anyDetailOpen ? 'unfold_less' : 'unfold_more' }}</i>
			</button>

			<button class="br-icon-btn"
					[class.br-icon-btn--active]="flip === 'active'"
					(click)="toggleData()"
					[title]="flip === 'active' ? 'Show chart' : 'Show table'">
				<i class="material-icons">{{ flip === 'active' ? 'bar_chart' : 'table_rows' }}</i>
			</button>
			<button class="br-icon-btn" (click)="exportXls()" [disabled]="sending" title="Export Excel">
				<i class="fa fa-file-excel-o"></i>
			</button>
			<button class="br-icon-btn" (click)="exportPdf()" [disabled]="sending" title="Export PDF">
				<i class="fa fa-file-pdf-o"></i>
			</button>
			<button class="br-icon-btn" (click)="loadData()" [disabled]="sending" title="Refresh">
				<i class="material-icons">refresh</i>
			</button>
			<button class="br-icon-btn"
					[class.br-icon-btn--active]="showFilters"
					(click)="showFilters = !showFilters"
					title="Filters">
				<i class="material-icons">tune</i>
			</button>
			<button class="br-icon-btn"
					[class.br-icon-btn--active]="expandedView"
					(click)="toggleExpandedView()"
					[title]="expandedView ? 'Exit expanded view (Esc)' : 'Expand to full screen'">
				<i class="material-icons">{{ expandedView ? 'close_fullscreen' : 'open_in_full' }}</i>
			</button>
		</div>
	</div>

	<!-- ── Summary stats ────────────────────────────────────────────────────── -->
	<div class="br-stats" *ngIf="data && data.length && !sending">
		<div class="br-stat">
			<span class="br-stat-val">{{ getTotal() | currency:'CAD':'symbol-narrow':'1.0-0' }}</span>
			<span class="br-stat-lbl">Total Net</span>
		</div>
		<div class="br-stat">
			<span class="br-stat-val">{{ data.length }}</span>
			<span class="br-stat-lbl">{{ groupPlural }}</span>
		</div>
		<div class="br-stat br-stat--wide">
			<span class="br-stat-val" [title]="data[0]?.label">{{ data[0]?.label }}</span>
			<span class="br-stat-lbl">Top {{ grouplabel }}</span>
		</div>
		<div class="br-stat">
			<span class="br-stat-val">{{ (getTotal() / data.length) | currency:'CAD':'symbol-narrow':'1.0-0' }}</span>
			<span class="br-stat-lbl">Avg</span>
		</div>
	</div>

	<!-- ── Filter drawer ────────────────────────────────────────────────────── -->
	<div class="br-filters" *ngIf="showFilters">
		<mat-form-field appearance="outline" class="br-field br-field--dates">
			<mat-label>Transaction Dates</mat-label>
			<mat-date-range-input [rangePicker]="picker">
				<input matStartDate [formControl]="fromdateCtrl" placeholder="Start">
				<input matEndDate [formControl]="todateCtrl" placeholder="End">
			</mat-date-range-input>
			<mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
			<mat-date-range-picker #picker></mat-date-range-picker>
		</mat-form-field>

		<mat-form-field *ngIf="!vendor" appearance="outline" class="br-field br-field--narrow-md">
			<mat-label>Group By</mat-label>
			<mat-select [formControl]="groupby" (selectionChange)="onDimensionChange()">
				<mat-option *ngFor="let g of groupOptions" [value]="g.value">{{ g.name }}</mat-option>
			</mat-select>
		</mat-form-field>

		<mat-form-field *ngIf="!vendor" appearance="outline" class="br-field br-field--narrow-md">
			<mat-label>Detail Each By</mat-label>
			<mat-select [formControl]="detailby" (selectionChange)="onDimensionChange()">
				<mat-option *ngFor="let g of detailOptions" [value]="g.value" [disabled]="g.value && g.value === groupby.value">{{ g.name }}</mat-option>
			</mat-select>
		</mat-form-field>

		<mat-form-field appearance="outline" class="br-field">
			<mat-label>Brand</mat-label>
			<mat-select [formControl]="brands" multiple appSelectAll>
				<mat-option *ngFor="let k of properties.brands" [value]="k.manufacturer_id">{{ k.name }}</mat-option>
			</mat-select>
		</mat-form-field>

		<mat-form-field *ngIf="!vendor" appearance="outline" class="br-field">
			<mat-label>Category{{ brandsNarrowed ? ' (brand)' : '' }}</mat-label>
			<mat-select [formControl]="categoryid" multiple appSelectAll>
				<mat-option *ngFor="let k of properties.categories" [value]="k.value">{{ k.name }}</mat-option>
			</mat-select>
			<mat-hint *ngIf="brandsNarrowed">{{ properties.categories?.length || 0 }} carried by the selected brand(s)</mat-hint>
		</mat-form-field>

		<mat-form-field appearance="outline" class="br-field">
			<mat-label>Product Line{{ brandsNarrowed ? ' (brand)' : '' }}</mat-label>
			<mat-select [formControl]="lineid" multiple appSelectAll>
				<mat-option *ngFor="let k of properties.productlines" [value]="k.value">{{ k.name }}</mat-option>
			</mat-select>
			<mat-hint *ngIf="brandsNarrowed">{{ properties.productlines?.length || 0 }} carried by the selected brand(s)</mat-hint>
		</mat-form-field>

		<!-- Reps are pinned to their own numbers server-side, so no picker for them. -->
		<mat-form-field *ngIf="!vendor && !issalesman && !salesmangated" appearance="outline" class="br-field">
			<mat-label>Salesperson</mat-label>
			<mat-select [formControl]="salespersons" multiple appSelectAll>
				<mat-option *ngFor="let sp of salespeople" [value]="sp.salesmancode">{{ sp.salesmanname }}</mat-option>
			</mat-select>
		</mat-form-field>

		<div class="br-gated-note" *ngIf="!vendor && (issalesman || salesmangated)">
			<i class="material-icons">lock</i>
			<span>Your sales only</span>
		</div>

		<mat-form-field appearance="outline" class="br-field br-field--narrow">
			<mat-label>Limit</mat-label>
			<mat-select [formControl]="limit">
				<mat-option *ngFor="let k of limits" [value]="k">{{ k }}</mat-option>
			</mat-select>
		</mat-form-field>

		<mat-form-field *ngIf="locations?.length > 1" appearance="outline" class="br-field">
			<mat-label>Warehouse</mat-label>
			<mat-select [formControl]="defaultlocation" multiple appSelectAll>
				<mat-option *ngFor="let loc of locations" [value]="loc.loccode">{{ loc.locationname }}</mat-option>
			</mat-select>
		</mat-form-field>

		<button class="br-apply-btn" (click)="loadData()" [disabled]="sending" title="Apply filters">
			<i class="material-icons">play_arrow</i>
			<span>Apply</span>
		</button>

		<button class="br-reset-btn" (click)="reset()" title="Reset filters">
			<i class="material-icons">refresh</i>
			<span>Reset</span>
		</button>
	</div>

	<!-- ── Full spinner (initial load) ──────────────────────────────────────── -->
	<div class="br-loading" *ngIf="sending">
		<svg class="spinner" width="40" height="40" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
			<circle class="path" fill="none" stroke-width="6" stroke-linecap="round" cx="33" cy="33" r="30"></circle>
		</svg>
	</div>

	<!-- ── Body ─────────────────────────────────────────────────────────────── -->
	<div class="br-body" *ngIf="!sending">

		<!-- ── Custom bar chart ── -->
		<div class="br-chart" [class.d-none]="flip === 'active'">

			<!-- Drill hint -->
			<div class="br-chart-hint" *ngIf="canDrill && data?.length">
				<i class="material-icons">touch_app</i>
				Click any bar to drill into product lines
			</div>
			<div class="br-chart-hint" *ngIf="detaillabel && data?.length">
				<i class="material-icons">touch_app</i>
				Click any row to show its {{ detaillabel | lowercase }} detail
			</div>
			<div class="br-chart-hint br-chart-hint--leaf" *ngIf="!canDrill && !detaillabel && data?.length">
				<i class="material-icons">account_tree</i>
				{{ grouplabel }} breakdown
			</div>

			<!-- Bars -->
			<div class="br-bar-group" *ngFor="let d of data; let i = index">

				<div class="br-bar-row"
					 [class.br-bar-row--clickable]="canDrill || hasDetails(d)"
					 [class.br-bar-row--top]="i === 0"
					 [class.br-bar-row--open]="isDetailOpen(d)"
					 (click)="onRowClick(d)">

					<!-- Rank -->
					<span class="br-rank" [class.br-rank--gold]="i === 0" [class.br-rank--silver]="i === 1" [class.br-rank--bronze]="i === 2">
						{{ i + 1 }}
					</span>

					<!-- Label -->
					<span class="br-bar-label" [title]="d.label">{{ d.label }}</span>

					<!-- Track -->
					<div class="br-bar-track">
						<div class="br-bar-fill" [style.width.%]="barsReady ? getBarPct(d) : 0"></div>
					</div>

					<!-- Right meta -->
					<div class="br-bar-meta">
						<span class="br-bar-meta-val">{{ formatShort(d.total) }}</span>
						<span class="br-bar-meta-sub">{{ getPctOfTotal(d) }}% · {{ d.qty | number:'1.0-0' }}u</span>
					</div>

					<!-- Drill arrow / detail expander -->
					<i class="material-icons br-bar-arrow" *ngIf="canDrill">chevron_right</i>
					<i class="material-icons br-bar-arrow br-bar-arrow--toggle" *ngIf="!canDrill && hasDetails(d)">
						{{ isDetailOpen(d) ? 'expand_less' : 'expand_more' }}
					</i>
					<span *ngIf="!canDrill && !hasDetails(d)"></span>
				</div>

				<!-- Per-row detail breakdown -->
				<div class="br-detail" *ngIf="isDetailOpen(d) && hasDetails(d)">
					<div class="br-detail-head">{{ detaillabel }} — {{ d.label }}</div>
					<div class="br-detail-row" *ngFor="let sub of d.details">
						<span class="br-detail-label" [title]="sub.label">{{ sub.label }}</span>
						<div class="br-detail-track">
							<div class="br-detail-fill" [style.width.%]="getDetailPct(d, sub)"></div>
						</div>
						<div class="br-detail-meta">
							<span class="br-detail-meta-val">{{ sub.total | currency:'CAD':'symbol-narrow':'1.0-0' }}</span>
							<span class="br-detail-meta-sub">{{ getDetailPctOfParent(d, sub) }}% · {{ sub.qty | number:'1.0-0' }}u</span>
						</div>
					</div>
				</div>

			</div>

			<div class="br-chart-empty" *ngIf="!data || !data.length">
				No data for the selected period.
			</div>
		</div>

		<!-- ── Drill loading overlay (sits over the chart) ── -->
		<div class="br-drill-overlay" *ngIf="drillLoading">
			<div class="br-drill-overlay-inner">
				<svg class="spinner" width="36" height="36" viewBox="0 0 66 66">
					<circle class="path" fill="none" stroke-width="6" stroke-linecap="round" cx="33" cy="33" r="30"></circle>
				</svg>
				<span>Loading...</span>
			</div>
		</div>

		<!-- ── Table (export / table view toggle) ── -->
		<div class="br-table-wrap" [class.d-none]="flip === 'inactive'" #print_items>
			<table class="br-table">
				<thead>
					<tr>
						<th>{{ grouplabel | uppercase }}</th>
						<th *ngIf="detaillabel">{{ detaillabel | uppercase }}</th>
						<th class="text-center">Units</th>
						<th class="text-right">Net</th>
					</tr>
				</thead>
				<tbody>
					<ng-container *ngFor="let d of data">
						<tr (click)="onRowClick(d)">
							<td class="br-cell-label">{{ d.label }}</td>
							<td *ngIf="detaillabel" class="br-cell-sub">{{ hasDetails(d) ? (d.details.length + ' ' + pluralize(detaillabel, d.details.length)) : '—' }}</td>
							<td class="text-center">{{ d.qty | number:'1.0-0' }}</td>
							<td class="text-right br-cell-total">{{ d.total | currency }}</td>
						</tr>
						<tr class="br-table-detail" *ngFor="let sub of d.details">
							<td></td>
							<td class="br-cell-sub">{{ sub.label }}</td>
							<td class="text-center">{{ sub.qty | number:'1.0-0' }}</td>
							<td class="text-right">{{ sub.total | currency }}</td>
						</tr>
					</ng-container>
				</tbody>
			</table>
		</div>

	</div>
</div>
